import React from 'react';
import '../css/accounting.css';

function TransactionModal({
  isOpen,
  onClose,
  onSave,
  entryType,
  setEntryType,
  amount,
  setAmount,
  description,
  setDescription,
  creditId,
  setCreditId,
  accountId,
  setAccountId,
  statementMonth,
  setStatementMonth,
  credits,
  accounts,
  statusMessage,
  isEditMode = false
}) {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="expense-modal" onClick={onClose}>
      <div className="expense-modal-card" onClick={(e) => e.stopPropagation()}>
        <div className="expense-modal-header">
          <div>
            <h3>{isEditMode ? 'Edit Transaction' : 'Add Transaction'}</h3>
            <p className="panel-sub">Enter transaction details and save.</p>
          </div>
          <button className="login-button" type="button" onClick={onClose}>Close</button>
        </div>
        <div className="form-grid">
          <div className="form-row">
            <label>
              Type
              <select value={entryType} onChange={(e) => setEntryType(e.target.value)}>
                <option value="debit">Debit</option>
                <option value="credit">Credit</option>
              </select>
            </label>
            <label>
              Amount
              <input type="number" step="0.01" value={amount} onChange={(e) => setAmount(e.target.value)} />
            </label>
          </div>
          <div className="form-row">
            <label>
              Description
              <input value={description} onChange={(e) => setDescription(e.target.value)} />
            </label>
            {entryType === 'credit' ? (
              <label>
                Credit account
                <select value={creditId} onChange={(e) => setCreditId(e.target.value)}>
                  <option value="">None</option>
                  {credits.map((credit) => (
                    <option key={credit.id} value={credit.id}>{credit.name}</option>
                  ))}
                </select>
              </label>
            ) : (
              <label>
                Account
                <select value={accountId} onChange={(e) => setAccountId(e.target.value)}>
                  <option value="">Select account</option>
                  {accounts.map((account) => (
                    <option key={account.id} value={account.id}>{account.name}</option>
                  ))}
                </select>
              </label>
            )}
          </div>
          <div className="form-row">
            <label>
              Statement month
              <input type="month" value={statementMonth} onChange={(e) => setStatementMonth(e.target.value)} />
            </label>
          </div>
          {statusMessage && (
            <div className="empty-state">{statusMessage}</div>
          )}
          <div className="form-row">
            <button className="login-button" type="button" onClick={onSave}>
              {isEditMode ? 'Update transaction' : 'Save transaction'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TransactionModal;
